/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import cx from 'classnames';
import styles from './ProgressBar.scss';

class ProgressBar extends Component {
  static defaultProps = {
    value: 0,
    maxValue: null,
    colorOnly: false,
  };

  static propTypes = {
    maxValue: PropTypes.any,
    value: PropTypes.number,
    text: PropTypes.string,
    dashForZero: PropTypes.bool,
    colorOnly: PropTypes.bool,
    small: PropTypes.bool,
    condensed: PropTypes.bool,
    indicatorClass: PropTypes.string,
    contentClass: PropTypes.string,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getIndicatorStyle(ratio) {
    if (ratio === 100) {
      return styles.complete;
    } else if (ratio === 0) {
      return styles.zero;
    } else if (ratio <= 20) {
      return styles['very-low'];
    } else if (ratio > 20 && ratio <= 40) {
      return styles.low;
    } else if (ratio > 40 && ratio <= 60) {
      return styles.med;
    } else if (ratio > 60 && ratio <= 80) {
      return styles.high;
    } else if (ratio > 80) {
      return styles['very-high'];
    }
    return '';
  }

  render() {
    const {
      maxValue,
      value,
      dashForZero,
      text,
      colorOnly,
      small,
      button,
      condensed,
      className,
      indicatorClass,
      contentClass,
      onClick,
      showIndicator = true,
    } = this.props;

    const isPercentageValue = maxValue === null;
    const roundedMaxValue = Math.round10(maxValue, -1);

    let ratio;
    let displayText;

    if (isPercentageValue) {
      // value passed in is a percentage amount
      const percentage = value < 1 ? value * 100 : value;
      const roundedPercentage = Math.round10(percentage, -1);
      ratio = percentage;
      displayText = `${roundedPercentage}%`;
    } else if (maxValue) {
      // ratio is either calculated from maxValue
      ratio = Math.round10((100 * Number(value)) / Number(maxValue));
      const roundedValue = Math.round10(value, -1);
      displayText = `${roundedValue || '0'}/${roundedMaxValue}`;
    } else {
      ratio = 0;
      displayText = '–';
    }

    // If we have zero and want a dash for zeros, ...
    if (dashForZero && (ratio === 0 || value === 0)) {
      displayText = '–';
    }

    const barStyle = { height: `${colorOnly || ratio > 100 ? 100 : ratio}%` };
    const indicatorStyles = this.getIndicatorStyle(ratio);

    return (
      <div
        className={cx(
          className,
          button ? styles.progressBarButton : styles.progressBar
        )}
        onClick={onClick}
        data-test="progress-bar"
      >
        {showIndicator && (
          <div
            className={cx(indicatorStyles, indicatorClass)}
            style={barStyle}
          />
        )}
        <div
          className={cx(
            styles.progressBarContent,
            { [styles.lowProgress]: !showIndicator && ratio <= 40 },
            contentClass
          )}
        >
          <p
            className={cx(
              styles.completion,
              { [styles.makeTextTiny]: small },
              { [styles.condensed]: condensed }
            )}
          >
            {displayText}
          </p>
          <p className={cx(styles.label, { [styles.makeTextTiny]: small })}>
            {text}
          </p>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default ProgressBar;
